<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row pb-2 m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
                [routerLink]="['/request/regularization/add/',0]" [disabled]="isDisabled">
                <i class="bi bi-fingerprint" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Regularization Request':'Loading...'}}
            </button>
        </div>
    </div>
</div>

<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        <div class="card-title">
            Regularization Request History
        </div>
    </div>
    <div class="card-body">
        <form class="g-3" name="filterForm" (ngSubmit)="Validate(filterForm)" #filterForm="ngForm" novalidate>
            <div class="row pb-2">
                <div class="col-md-3">
                    <label for="FromDate" class="text-label-dark">From Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="FromDate"
                            [(ngModel)]="Filter.FromDate" ngbDatepicker #FromDate="ngbDatepicker" readonly required
                            [disabled]="Filter.IsWithdraw" (ngModelChange)="Clear()"/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                            type="button" [disabled]="Filter.IsWithdraw"></button>
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="ToDate" class="text-label-dark">To Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="ToDate" [(ngModel)]="Filter.ToDate"
                            ngbDatepicker #ToDate="ngbDatepicker" readonly required [disabled]="Filter.IsWithdraw" (ngModelChange)="Clear()"/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                            type="button" [disabled]="Filter.IsWithdraw"></button>
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="ApprovalStatus" class="form-font-label">Status</label>
                    <select class="form-select" aria-label="ApprovalStatus" placeholder="Status" title="Status"
                        name="Status" data-live-search="true" [(ngModel)]="Filter.ApprovalStatus"
                        #ApprovalStatus="ngModel" required [disabled]="Filter.IsWithdraw" (change)="Clear()">
                        @for (status of common.Status; track status.Value; let i = $index) {
                        <option [value]="status.Value">
                            <div class="row">
                                <div class="col">{{status.Name}}</div>
                            </div>
                        </option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        Please select Approval Status!
                    </div>
                </div>
                <div class="col" style="align-content: center;font-weight: 500;font-size: 15px;">
                    <span class="Label" style="margin-left: 3%;">
                        <input type="checkbox" name="admincharg" [(ngModel)]="Filter.IsWithdraw" ngbCheckbox
                            (change)="Clear()" />
                        Withdraw Only
                    </span>
                </div>
                <div class="col-md-auto mt-4">
                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}
                    </button>
                </div>
            </div>
        </form>
        <div>
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">View</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">Withdraw</th>
                        <!-- <th>Details</th> -->
                        <th style="width: 305px;">{{common.ToLowerCase(user.EmpType) == 'front'?'Client Location':common.ToLowerCase(user.EmpType) == 'back'?'Branch':''}}</th>
                        <th>Type</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th [ngClass]="{'colHide': this.Filter.IsWithdraw}">Reason</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">Status</th>
                        <!-- <th style="width: 5px;">Action</th>
                        <th>Transaction</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let RegularizationDatas of RegularizationDatas;let i=index">
                        <td style="width: 5px;">{{i+1}}</td>
                        <td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            <div style="width: 80px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                    [routerLink]="['/request/regularization/detail/',RegularizationDatas.RegularizationAttendanceDetailsID]"><i
                                        class="bi bi-info-square me-1"></i>View</button></div>
                        </td>
                        <td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            <div style="width: 110px;"
                                *ngIf="common.ToLowerCase(RegularizationDatas['ApprovalStatus']) == 'pending'"><button type="button"
                                    class="btn btn-outline-primary btn-sm" (click)="SaveRegularizationAttendance(i)"><i
                                        class="bi bi-x-circle me-1"></i>Withdraw</button></div>
                        </td>

                        <!-- <td>
                            <div class="row no-gutters" style="align-items: center;width: 300px;">
                                <div class="col-2">
                                    <img mat-card-image class="userImage rounded"
                                        [src]="common.PhotoLink(RegularizationDatas.Photo)" />
                                </div>
                                <div class="col-10">
                                    <span class="text-label">{{RegularizationDatas.EmployeeName}}</span><br />
                                    <span class="text-label-light">#{{RegularizationDatas.EmpCode}}</span><br />
                                    <span class="text-label-light">{{RegularizationDatas.DesignationName}}</span>
                                </div>
                            </div>
                        </td> -->
                        <td style="width: 305px;">
                            <div style="width: 305px;">{{common.ToLowerCase(user.EmpType) ==
                                'front'?RegularizationDatas.ClientLocation:common.ToLowerCase(user.EmpType) ==
                                'back'?RegularizationDatas.BranchName:''}}</div>
                        </td>
                        <td>{{RegularizationDatas.AttendanceStatus}}</td>
                        <td>{{RegularizationDatas.AttendanceDate | date: 'dd MMM yyyy' }}</td>
                        <td>{{ (common.ToLowerCase(RegularizationDatas.AttendanceStatus) === 'in' ?
                            RegularizationDatas.InTime
                            :
                            RegularizationDatas.OutTime) | date : 'H:mm:ss' }}</td>
                        <td [ngClass]="{'colHide': this.Filter.IsWithdraw}">{{common.ToLowerCase(RegularizationDatas.AttendanceStatus) === 'in' ?
                            RegularizationDatas.InReason
                            :
                            common.ToLowerCase(RegularizationDatas.AttendanceStatus) === 'out' ?
                            RegularizationDatas.OutReason
                            :
                            ''}} </td>
                        <td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            <span class="badge"
                                [ngClass]="{'success':common.ToLowerCase(RegularizationDatas.ApprovalStatus) == 'approved', 'warning':common.ToLowerCase(RegularizationDatas.ApprovalStatus) == 'pending','danger':common.ToLowerCase(RegularizationDatas.ApprovalStatus) == 'rejected'}">
                                {{RegularizationDatas.ApprovalStatus}}</span>
                        </td>
                        <!-- <td style="width: 5px;">
                            <div ngbDropdown class="d-inline-block arrow-none">
                                <i class="bi bi-three-dots-vertical" id="dropdownOption" aria-expanded="false"
                                    ngbDropdownToggle></i>
                                <div ngbDropdownMenu aria-labelledby="dropdownOption"
                                    *ngIf="RegularizationDatas.ApprovalStatus=='Pending'">
                                    <div class="row px-2">
                                        <div class="col"><i class="bi bi-pencil-square"></i></div>
                                        <div class="col-auto">Withdraw</div>
                                    </div>
                                </div>
                            </div>

                        </td> -->
                        <!-- <td>
                            <div style="width: 110px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="Tracking(RegularizationDatas.TransactionId)"><i
                                        class="bi bi-clock-history me-2"></i>History</button></div>
                        </td> -->

                    </tr>

                </tbody>
            </table>
        </div>
    </div>

</div>